// src/config/constants.js

/**
 * 小程序代码常量配置
 */
export const MINI_PROGRAM_CODES = {
  YHRL: 'CJTG_XCX_YHRL', // 易花日历小程序
  YHAI: 'CJTG_XCX_YHAI', // 易花AI助手小程序
  YHH: 'CJTG_XCX_YHH', // 易花花小程序
  LZ: 'CJTG_XCX_LZ', // 易借速贷小程序
  YHPHZS: 'CJTG_XCX_YHPHZS', // 易花普惠助手小程序
  YHZX: 'CJTG_XCX_YHZX', // 易花智选小程序
  YHYX: 'CJTG_XCX_YHYX', // 易花优享小程序
  YHQYPT: 'CJTG_XCX_YHQYPT', // 易花权益平台小程序
  YHSHFW: 'CJTG_XCX_YHSHFW' // 易花生活服务小程序
}

/**
 * 所有小程序代码数组
 */
export const MINI_PROGRAM_CODE_LIST = [
  MINI_PROGRAM_CODES.LZ,
  MINI_PROGRAM_CODES.YHH,
  MINI_PROGRAM_CODES.YHAI,
  MINI_PROGRAM_CODES.YHRL,
  MINI_PROGRAM_CODES.YHPHZS,
  MINI_PROGRAM_CODES.YHZX,
  MINI_PROGRAM_CODES.YHYX,
  MINI_PROGRAM_CODES.YHQYPT,
  MINI_PROGRAM_CODES.YHSHFW
]

/**
 * 判断 lzCode 是否为小程序代码
 * @param {string} lzCode - 渠道代码
 * @returns {boolean}
 */
export function isMiniProgramCode (lzCode) {
  return MINI_PROGRAM_CODE_LIST.includes(lzCode)
}

/**
 * 判断 lzCode 是否为目标小程序
 * @param {string} lzCode - 渠道代码
 * @param {array} targetLzCode - 目标渠道代码
 * @returns {boolean}
 */
export function isTargetMiniProgram (lzCode, targetLzCode) {
  return targetLzCode.includes(lzCode)
}

/**
 * 根据渠道名称获取对应的小程序代码
 * @param {string} channelName - 渠道名称（如 'LZ', 'YHH', 'YHAI'）
 * @returns {string} 小程序代码
 */
export function getMiniProgramCodeByChannel (channelName) {
  const channel = channelName?.toUpperCase()
  switch (channel) {
    case 'YJSD':
      return MINI_PROGRAM_CODES.LZ
    default:
      return MINI_PROGRAM_CODES.YHH
  }
}
// 无代偿后可用通道的提前结清专用错误码；不能把其他3001场景当成维护弹窗。
export const EARLY_SETTLEMENT_NO_CHANNEL_CODE = 1968
